import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const logos = [
    "/images/bmw.jpeg",
    "/images/renault.jpeg",
    "/images/mahinda.webp",
    "/images/audi.png",
    "/images/ford.png",
    "/images/honda.png",
    "/images/toyota.jpeg",
    "/images/jaguar.png",
    "/images/maruti.jpeg",
    "/images/mg.png",
    "/images/volkswagen.png",
  ];

  const testimonials = [
    {
      text: "Fast and reliable service. My car's battery was drained out, so I called them and booked the service. The service provider arrived within 20 mins and solved the problem. I will highly recommend this company for emergency situations and breakdowns.",
      name: "Rajat Sharma",
      country: "India",
    },
    {
      text: "Quick response and excellent service. My car's battery was drained out, so I called them for service and they sent the mechanic within 30 mins who solved the problem in no time. I will highly recommend this company for emergency situations and breakdowns.",
      name: "Ankit Rajput",
      country: "India",
    },
    {
      text: "Best service. My car got stuck due to some technical issues on the Bangalore ORR at around 12:30 AM night. Without panic I called these guys and my call got picked up within seconds, and they have assigned a technician within 10 mins. Such an awesome flawless experience. Highly recommended!",
      name: "Naval Saini",
      country: "India",
    },
  ];

  const [activeIndex, setActiveIndex] = useState([0, 5]);

  const toggle = (index) => {
    setActiveIndex(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // close
          : [...prev, index], // open
    );
  };
  const faqs = [
    {
      q: "Q1: What services does Road Mechanic 24x7 provide?",
      a: "A1: Road Mechanic 24x7 offers a comprehensive range of roadside assistance services, including tyre assistance, battery jumpstarts, fuel delivery, lockout assistance, on-site mechanical repairs, and towing services.",
    },
    {
      q: "Q2: How do I contact Road Mechanic 24x7 in case of an emergency?",
      a: "A2: In case of an emergency, simply dial our 24/7 hotline. Our customer service representatives will guide you through the process, gather necessary information, and dispatch a certified technician to your location promptly.",
    },
    {
      q: "Q3: Is Road Mechanic 24x7 available nationwide?",
      a: "A3: Yes, Road Mechanic 24x7 provides nationwide coverage. Whether you're close to home or traveling across the country, our network of skilled technicians is ready to assist you wherever you are.",
    },
    {
      q: "Q4: What is the average response time for Road Mechanic 24x7?",
      a: "A4: We understand the importance of a quick response during roadside emergencies. Our goal is to have a certified technician at your location as quickly as possible, typically within a short timeframe after your call.",
    },
    {
      q: "Q5: How are service costs determined?",
      a: "A5: Road Mechanic 24x7 believes in transparent pricing. Our technicians will provide a clear breakdown of the costs before starting any work. You'll know the price upfront, with no hidden fees.",
    },
    {
      q: "Q6: Can Road Mechanic 24x7 handle more extensive repairs that can't be done on-site?",
      a: "A6: Yes, if on-site repairs are not possible, Road Mechanic 24x7 offers towing services. We'll arrange for your vehicle to be safely transported to the nearest service center for more extensive repairs.",
    },
    {
      q: "Q7: Are the technicians at Road Mechanic 24x7 certified and experienced?",
      a: "A7: Absolutely. Our technicians are certified and experienced professionals with the expertise to handle a variety of roadside issues. They undergo regular training to stay updated on the latest industry standards.",
    },
    {
      q: "Q8: Can I use Road Mechanic 24x7 even if I'm not a member?",
      a: "A8: While we offer membership plans for additional benefits, Road Mechanic 24x7 provides assistance to both members and non-members. You can call us for help whenever you need roadside assistance.",
    },
    {
      q: "Q9: How do I pay for Road Mechanic 24x7 services?",
      a: "A9: Payment for Road Mechanic 24x7 services can be conveniently processed on-site. Our technicians will provide you with a clear breakdown of the costs, and you can settle the payment using various available payment methods.",
    },
    {
      q: "Q10: Is there a satisfaction guarantee with Road Mechanic 24x7 services?",
      a: "A10: Yes, your satisfaction is our priority. We strive to provide reliable and efficient service, and if you have any concerns, please contact our customer service team. We are committed to ensuring your experience with Road Mechanic 24x7 is positive and stress-free.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Vinayak24x7 | 24x7 Car Breakdown Service in Jaipur</title>

        <meta
          name="description"
          content="Vinayak24x7 provides 24x7 car breakdown service in Jaipur. Emergency roadside assistance, tyre puncture repair, battery jumpstart and on-call mechanic support."
        />

        <link rel="canonical" href="https://vinayak24x7.com/" />
      </Helmet>

      <div className="container-fluid p-0">
        <header className="header-section">
          <div className="overlay">
            <div className="container text-white">
              <div className="row">
                <div className="col-md-6">
                  <h1>Vinayak24x7 – 24x7 Car Breakdown Service in Jaipur</h1>

                  <p>
                    Car Breakdown Help: Quick Solutions for Roadside Assistance,
                    Car Battery, Flat Tyre, Car Mechanic Services And Crane
                    Service.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="service-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="topUspsmain">
                  <div
                    className="topUspsinner d-flex"
                    style={{
                      height: "230px", // 🔴 REQUIRED
                      width: "100%",
                      backgroundImage: "url(/images/cartowing.jpg)",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div className="uspIcon">
                      <i className="fa-solid fa-gear" />
                    </div>
                    <div className="uspText">
                      <div>
                        <p>Car Towing Services</p>
                        <p>
                          Reliable car crane services: fast, efficient towing
                          solutions for any breakdown or accident. Get back on
                          the road quickly!
                        </p>
                        <button className="custmBtn">Learn More</button>
                      </div>
                    </div>
                  </div>
                  <div className="topUspsinner">
                    <div className="uspinnContainer">
                      <div className="uspIcon">
                        <i className="fa-solid fa-toolbox" />
                      </div>
                      <div className="uspText">
                        <p>Flat tyre Services</p>
                        <p>
                          Fast and reliable flat Tyre services: Get your flat
                          Tyre fixed quickly with expert roadside assistance and
                          quality repairs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="topUspsinner">
                    <div className="uspinnContainer">
                      <div className="uspIcon">
                        <i className="fa-solid fa-toolbox" />
                      </div>
                      <div className="uspText">
                        <p>Car Mechanic Near Me</p>
                        <p>
                          Find a reliable car mechanic near you for expert
                          repairs and maintenance. Quick, professional service
                          to keep your vehicle running smoothly.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="topUspsinner">
                    <div className="uspinnContainer">
                      <div className="uspIcon">
                        <i className="fa-solid fa-toolbox" />
                      </div>
                      <div className="uspText">
                        <p>Fuel Delivery</p>
                        <p>
                          Emergency Fuel Delivery: Fast and Reliable Roadside
                          Assistance Service for Running Out of Gas and Getting
                          Back on Track.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="servicesBg">
        <div className="container text-center my-5">
          <div className="row">
            <div className="col-md-12">
              <div className="offer-section">
                <p className="offer-subtitle">What We Offer</p>
                <p className="offer-title">
                  Overcome Car Breakdowns: Get Moving-
                  <br />
                  class service
                </p>
                <p className="offer-description">
                  Discover our roadside assistance services: fast help for
                  breakdowns, battery issues, flat Tyre, and more to get you
                  moving quickly.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon vehicle-towing">
                  <img
                    src="/images/vehicle_towing.png"
                    alt="vehicle_towing.jpg"
                  />
                </div>
                <p className="service-title">Vehicle Towing</p>
                <p className="service-description">
                  Expert vehicle towing and roadside assistance services for
                  quick recovery and peace of mind.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon motorcycle-towing">
                  <img
                    src="/images/batter_jumpstart.png"
                    alt="Battry-Jumpstart"
                  />
                </div>
                <p className="service-title">Car Battry Jumpstart</p>
                <p className="service-description">
                  Reliable Car Battery Jumpstart Service: Fast Solutions to Get
                  Your Vehicle Running Again.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon jump-start">
                  <img
                    src="/images/instant_car_repair.png"
                    alt="car-repairing"
                  />
                </div>
                <p className="service-title">Instant Car Repair</p>
                <p className="service-description">
                  Instant Car Repair: Fast solutions for breakdowns, battery
                  issues, flat Tyre, and more
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon Tyre-change">
                  <img
                    src="/images/mechanical_fault.png"
                    alt="Mechanical Fault"
                  />
                </div>
                <p className="service-title">Mechanical Fault</p>
                <p className="service-description">
                  Resolve Mechanical Faults: Expert Tips and Solutions for
                  Common Car Issues and Repairs
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon gasoline-delivery">
                  <img src="/images/car_locked.png" alt="Key-LockOut" />
                </div>
                <p className="service-title">Key LockOut</p>
                <p className="service-description">
                  Key Lockout Solutions: Fast Help for Car, Home, and Office
                  Lockouts. Call Now!
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-box">
                <div className="service-icon winch-out">
                  <img src="/images/flat_tyre.png" alt="body-repair" />
                </div>
                <p className="service-title">Flat Tyre Service</p>
                <p className="service-description">
                  Flat Tyre Service: Fast and Reliable Solutions for Quick
                  Roadside Assistance and Tyre Repair.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="abtSection">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="description-section">
                <h2>WHO WE ARE</h2>
                <p>
                  About <b style={{ color: "#FD3818" }}>vinayak 24x7</b>
                </p>
                <p>
                  When life throws unexpected challenges your way on the road,
                  count on Road Mechanic 24x7 to be your trusted companion. Our
                  roadside assistance service is designed to provide quick,
                  efficient, and reliable support whenever you find yourself
                  stranded. Whether it's a flat Tyre, dead battery, or any other
                  unexpected vehicle issue, Road Mechanic 24x7 is just a call
                  away, ready to get you back on the road
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="fa-ul">
                      <li> Battery Jumpstart</li>
                      <li> Fuel Delivery</li>
                      <li> Lockout Assistance</li>
                      <li> Mechanical Repairs</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="fa-ul">
                      <li> Towing Services</li>
                      <li> Tyre Assistance</li>
                      <li> 24x7 services</li>
                      <li> Instant Car Repair</li>
                    </ul>
                  </div>
                </div>
                <div className="contact-section mt-4">
                  <div className="icon">
                    <i className="fas fa-headset" />
                  </div>
                  <div className="text">
                    <h3>24/7 Emergency Towing</h3>
                    <h4>+91 6367607678</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="position-relative mrgnsm">
                <img
                  src="/images/roadside-assistance.jpg"
                  alt="Towing Service"
                  className="img-fluid"
                />
                <div className="experience-badge position-absolute">
                  <h2>25 +</h2>
                  <p>Years of Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="logosliderMain custmMargin">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="brandsDiv">
                <h2>
                  Premium Cars Brands <br /> We Service
                </h2>
                <p>
                  Top Premium Car Brands We Service: Expert Maintenance and
                  Repairs for Luxury Vehicles.
                </p>
              </div>
            </div>
            <div className="col-md-8">
              <Swiper
                modules={[Autoplay]}
                loop
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                spaceBetween={15}
                breakpoints={{
                  0: { slidesPerView: 1 }, // mobile
                  480: { slidesPerView: 2 }, // small mobile
                  768: { slidesPerView: 3 }, // tablet & up
                }}
                className="logoSlider"
              >
                {logos.map((logo, index) => (
                  <SwiperSlide key={index}>
                    <div className="logoSliderDiv">
                      <img src={logo} alt="brand" />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section className="bgStrips">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="offer-section text-center">
                <p className="offer-subtitle">TESTIMONIAL</p>
                <p className="offer-title">What they say</p>
                <p className="offer-description">
                  See What Our Clients Say About Our Reliable Services and
                  Support.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Swiper
                modules={[Autoplay, Pagination]}
                loop
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                spaceBetween={15}
                pagination={{ clickable: true }}
                breakpoints={{
                  0: { slidesPerView: 1 }, // mobile
                  768: { slidesPerView: 2 }, // tablet
                  1024: { slidesPerView: 2 }, // desktop
                }}
                className="blog_slider_area"
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="testimonialCont">
                      <p>{item.text}</p>
                      <div className="tabcontent01">
                        <div className="tbContent101">
                          <p>{item.name}</p>
                          <p>{item.country}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section className="custmMargin">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="offer-section text-center">
                <p className="offer-title">Frequently Asked Questions</p>
                <p className="offer-description">
                  Discover answers to frequently asked questions about roadside
                  assistance. Get insights on services, costs, and coverage for
                  emergencies like breakdowns, flat Tyre, and more.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="accordion-container">
                <div className="accordion-column">
                  {faqs.slice(0, 5).map((item, index) => (
                    <div className="accordion-item" key={index}>
                      <button
                        className={`accordion-header ${
                          activeIndex.includes(index) ? "active" : ""
                        }`}
                        onClick={() => toggle(index)}
                      >
                        {item.q}
                      </button>

                      {activeIndex.includes(index) && (
                        <div className="accordion-content">
                          <p>{item.a}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="accordion-column">
                  {faqs.slice(5).map((item, index) => {
                    const realIndex = index + 5;
                    return (
                      <div className="accordion-item" key={realIndex}>
                        <button
                          className={`accordion-header ${
                            activeIndex.includes(realIndex) ? "active" : ""
                          }`}
                          onClick={() => toggle(realIndex)}
                        >
                          {item.q}
                        </button>

                        {activeIndex.includes(realIndex) && (
                          <div className="accordion-content">
                            <p>{item.a}</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container custmMargin">
        <div className="row">
          <div className="col-md-12">
            <div className="offer-section text-center">
              <p className="offer-title">How it works</p>
              <p className="offer-description">
                Steps to Access 24/7 Roadside Assistance: Quick and easy guide
                to avail roadside mechanic services, including Tyre changes,
                battery boosts, and towing anytime, anywhere.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="desktop-view mb-3">
              <svg
                width="1200"
                height="260"
                viewBox="0 0 1200 260"
                xmlns="http://www.w3.org/2000/svg"
              >
                <style>{`
        .card { fill: #ffffff; stroke: #f9a602; stroke-width: 2; rx: 16; }
        .icon { fill: none; stroke: #f9a602; stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; }
        .title { font-family: Arial, sans-serif; font-size: 16px; font-weight: bold; fill: #000000; }
        .text { font-family: Arial, sans-serif; font-size: 13px; fill: #444444; }
        .line { stroke: #f9a602; stroke-width: 2; stroke-dasharray: 6 6; }
      `}</style>

                {/* Connector lines */}
                <line x1="220" y1="130" x2="260" y2="130" className="line" />
                <line x1="420" y1="130" x2="460" y2="130" className="line" />
                <line x1="620" y1="130" x2="660" y2="130" className="line" />
                <line x1="820" y1="130" x2="860" y2="130" className="line" />

                {/* Step 1 */}
                <rect
                  x="40"
                  y="60"
                  width="180"
                  height="140"
                  rx="16"
                  className="card"
                />
                <circle cx="130" cy="95" r="18" className="icon" />
                <path d="M124 92 L136 98" className="icon" />
                <text x="70" y="140" className="title">
                  Customer Call
                </text>
                <text x="55" y="165" className="text">
                  User calls our road
                </text>
                <text x="60" y="182" className="text">
                  assistance helpline
                </text>

                {/* Step 2 */}
                <rect
                  x="260"
                  y="60"
                  width="180"
                  height="140"
                  rx="16"
                  className="card"
                />
                <path d="M350 85 q15 10 0 20 q-15 10 0 20" className="icon" />
                <text x="290" y="140" className="title">
                  Support Team
                </text>
                <text x="280" y="165" className="text">
                  Our team understands
                </text>
                <text x="290" y="182" className="text">
                  the vehicle issue
                </text>

                {/* Step 3 */}
                <rect
                  x="460"
                  y="60"
                  width="180"
                  height="140"
                  rx="16"
                  className="card"
                />
                <rect x="530" y="80" width="40" height="30" className="icon" />
                <circle cx="540" cy="115" r="6" className="icon" />
                <circle cx="565" cy="115" r="6" className="icon" />
                <text x="485" y="140" className="title">
                  Team Assigned
                </text>
                <text x="480" y="165" className="text">
                  Nearest service team
                </text>
                <text x="500" y="182" className="text">
                  is dispatched
                </text>

                {/* Step 4 */}
                <rect
                  x="660"
                  y="60"
                  width="180"
                  height="140"
                  rx="16"
                  className="card"
                />
                <path d="M720 110 L780 110" className="icon" />
                <path d="M735 95 L720 110 L735 125" className="icon" />
                <text x="690" y="140" className="title">
                  Team Reaches
                </text>
                <text x="685" y="165" className="text">
                  Technicians arrive
                </text>
                <text x="700" y="182" className="text">
                  at your location
                </text>

                {/* Step 5 */}
                <rect
                  x="860"
                  y="60"
                  width="180"
                  height="140"
                  rx="16"
                  className="card"
                />
                <path d="M920 110 L935 125 L960 95" className="icon" />
                <text x="885" y="140" className="title">
                  On-Spot Repair
                </text>
                <text x="880" y="165" className="text">
                  Vehicle issue fixed
                </text>
                <text x="900" y="182" className="text">
                  successfully
                </text>
              </svg>
            </div>
            <div className="mobile-view mb-3">
              <svg
                width="360"
                height="650"
                viewBox="0 0 360 650"
                xmlns="http://www.w3.org/2000/svg"
              >
                <style>{`
        .card { fill:#ffffff; stroke:#f9a602; stroke-width:2; rx:14; }
        .icon { fill:none; stroke:#f9a602; stroke-width:3; stroke-linecap:round; stroke-linejoin:round; }
        .title { font-family:Arial, sans-serif; font-size:15px; font-weight:bold; fill:#000; }
        .text { font-family:Arial, sans-serif; font-size:13px; fill:#444; }
        .line { stroke:#f9a602; stroke-width:2; stroke-dasharray:5 5; }
      `}</style>

                {/* Lines */}
                <line x1="180" y1="120" x2="180" y2="150" className="line" />
                <line x1="180" y1="250" x2="180" y2="280" className="line" />
                <line x1="180" y1="380" x2="180" y2="410" className="line" />
                <line x1="180" y1="510" x2="180" y2="540" className="line" />

                {/* Step 1 */}
                <rect
                  x="40"
                  y="40"
                  width="280"
                  height="80"
                  rx="14"
                  className="card"
                />
                <circle cx="70" cy="80" r="14" className="icon" />
                <path d="M66 78 L74 82" className="icon" />
                <text x="100" y="70" className="title">
                  Customer Call
                </text>
                <text x="100" y="92" className="text">
                  Call our road assistance helpline
                </text>

                {/* Step 2 */}
                <rect
                  x="40"
                  y="150"
                  width="280"
                  height="80"
                  rx="14"
                  className="card"
                />
                <path d="M60 170 q12 8 0 16 q-12 8 0 16" className="icon" />
                <text x="100" y="180" className="title">
                  Support Team Talks
                </text>
                <text x="100" y="202" className="text">
                  We understand the issue
                </text>

                {/* Step 3 */}
                <rect
                  x="40"
                  y="280"
                  width="280"
                  height="80"
                  rx="14"
                  className="card"
                />
                <rect x="52" y="300" width="36" height="20" className="icon" />
                <circle cx="58" cy="324" r="5" className="icon" />
                <circle cx="78" cy="324" r="5" className="icon" />
                <text x="100" y="310" className="title">
                  Team Dispatched
                </text>
                <text x="100" y="332" className="text">
                  Nearest team is assigned
                </text>

                {/* Step 4 */}
                <rect
                  x="40"
                  y="410"
                  width="280"
                  height="80"
                  rx="14"
                  className="card"
                />
                <path d="M56 450 L84 450" className="icon" />
                <path d="M66 438 L56 450 L66 462" className="icon" />
                <text x="100" y="440" className="title">
                  Team Reaches Location
                </text>
                <text x="100" y="462" className="text">
                  Technicians arrive on-site
                </text>

                {/* Step 5 */}
                <rect
                  x="40"
                  y="540"
                  width="280"
                  height="80"
                  rx="14"
                  className="card"
                />
                <path d="M56 578 L66 588 L86 566" className="icon" />
                <text x="100" y="570" className="title">
                  On-Spot Repair
                </text>
                <text x="100" y="592" className="text">
                  Vehicle issue resolved
                </text>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
